import React from 'react'

import FormRow from '../components/FormRow'
import ImageSlider from '../components/ImageSlider'
import FormSocials from '../components/FormSocials'

import { Input, TextArea, FormFiles, SelectCountry } from '../../ui/inputs'

export const ExhibitorForm = ({
  media,
  bindInput,
  handleUpload,
  handleDelete,
}) => {
  return (
    <>
      <ImageSlider files={media.image} name="image" onChange={handleUpload} />

      <FormRow label="Exhibitor Images">
        <FormFiles
          files={media.image}
          name="image"
          onChange={handleUpload}
          onDelete={handleDelete}
        />
      </FormRow>

      <FormRow label="Name">
        <Input placeholder="Name" {...bindInput('name')} />
      </FormRow>

      <FormRow label="Country">
        <SelectCountry {...bindInput('country')} />
      </FormRow>

      <FormRow label="Company">
        <Input placeholder="Company Name" {...bindInput('company')} />
      </FormRow>

      <FormRow label="Email">
        <Input placeholder="Email" {...bindInput('email')} />
      </FormRow>

      <FormRow label="Phone Number">
        <Input placeholder="+372 " {...bindInput('phone')} />
      </FormRow>

      <FormRow label="Exhibitor Booth">
        <Input placeholder="7 " {...bindInput('booth')} />
      </FormRow>

      <FormRow label="About exhibitor" inline={false}>
        <TextArea placeholder="About exhibitor" {...bindInput('description')} />
      </FormRow>

      <FormSocials bindInput={bindInput} />
    </>
  )
}

export default ExhibitorForm
